export default __webpack_public_path__ + "static/media/heat-treatment_1.59e2194e.png";